import { getBoundaryColourByLevel } from '@/helpers/colour';

const formatter = 'timeline';

/**
   * Format result data that is in a timeseries format (resultData will be an array)
   *
   * @param {Kpi} kpi
   * @param {Array} resultData
   * @param {Array} relevanceData
   */
export default function formatTimeline(kpi, resultData) {
  const displayType = kpi.getDisplayType();
  const displayData = {
    key: 'Data 1',
    type: 'bar',
    hoverinfo: 'x+text',
    values: [],
  };

  if (typeof resultData !== 'object') {
    return {
      displayType,
      displayData,
      percent: kpi.isPercent(),
      formatter,
    };
  }

  const { data } = resultData;

  // Escape if there is too much data
  // @TODO handle this is a better way
  if (data.length > 2000) {
    return {
      displayType,
      displayData,
      percent: kpi.isPercent(),
      formatter,
    };
  }

  const points = data.map(({ x, displayY0, level0 }) => ({
    x: new Date(x),
    y: 1,
    colour: getBoundaryColourByLevel(level0),
    text: `${kpi.name}: ${displayY0}`,
  }));

  displayData.values = points;
  return {
    displayType,
    displayData,
    isPercent: kpi.isPercent(),
    formatter,
  };
}
